import { notification } from "antd";
import { ReactComponent as Success } from "../../assets/success.svg";
import { ReactComponent as Error } from "../../assets/error.svg";


export const triggerNotification = ({
  message = "Successful Action",
  description = "The action has been successfully completed.",
  status,
  onClick,
  duration = 3,
  Icon
}) => {
  notification.open({
    message,
    description,
    onClick,
    duration,
    icon: status === 'Error' ? <Error /> : <Success />
  });
};
